// extracted by mini-css-extract-plugin
export var label = "_cb-1";
export var reminder = "_cb-0";